module.exports = __webpack_public_path__ + "fonts/SFUIText-MediumItalic.bced79e3.woff";